import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from "@angular/core";
import { DashLangService } from "../../../../modules/home/dash/service/dash.lang.service";
import { s25Resource } from "../../../../util/s25.resource";
import { LoginStore } from "../../../../stores/login.store";
import { TypeManagerDecorator } from "../../../../main/type.map.service";
import type { HomeDashCustomize } from "../panel/home.dash.panel.model";
import type { HomeDashSectionModel } from "./home.dash.section.model";
import { HomeDashSectionCustomizeComponent } from "./home.dash.section.customize.component";
import { HomeDashSectionRegularComponent } from "./home.dash.section.regular.component";
import { HomeDashSectionToolboxComponent } from "./home.dash.section.toolbox.component";

@TypeManagerDecorator("s25-ng-dash-section")
@Component({
    selector: "s25-ng-dash-section",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        HomeDashSectionToolboxComponent,
        HomeDashSectionRegularComponent,
        HomeDashSectionCustomizeComponent,
    ],
    template: `
        @if (sectionKind(); as kind) {
            @switch (kind) {
                @case ("toolbox") {
                    <div class="col-sm-48 dashSection">
                        <s25-ng-dash-section-toolbox
                            [section]="section()"
                            [customize]="customize()"
                            (resetDash)="resetDash.emit()"
                        />
                    </div>
                }
                @case ("regular") {
                    <div class="col-sm-16 switch-regular">
                        <s25-ng-dash-section-regular
                            [section]="section()"
                            [customize]="customize()"
                            [isToolbox]="false"
                        />
                        @if (isLast() && loginStore.loggedIn()) {
                            <s25-ng-dash-section-customize />
                        }
                    </div>
                }
            }
        }
    `,
})
export class HomeDashSectionComponent {
    readonly section = input.required<HomeDashSectionModel>();
    readonly isLast = input(false);
    readonly customize = input.required<HomeDashCustomize>();
    readonly resetDash = output<void>();

    readonly loginStore = inject(LoginStore);
    readonly dashLang = s25Resource(() => DashLangService.getLang());

    readonly sectionKind = computed(() => {
        const langVal = this.dashLang.value();
        const sec = this.section();
        if (!langVal?.section?.type || sec == null) {
            return undefined;
        }
        const typeMap = langVal.section.type as Record<number, string>;
        return typeMap[sec.typeId];
    });
}
